import ScreenSizeLayout from './ScreenSizeLayout';

export default ScreenSizeLayout;
